import {styled} from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({theme}) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const GlobalModal = ({
  open,
  handleClose,
  title,
  subtitle,
  children,
  dialogActions = null,
  closeIcon = true,
  dialogContent = null,
  dialogContentClass = "",
  dialogTitleClass = "",
  fullWidth = true,
  maxWidth = "sm",
  disableBackdropClick = false,
}) => {
  return (
    <BootstrapDialog
      onClose={disableBackdropClick ? null : handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      {title && (
        <DialogTitle
          sx={{m: 0, p: 2}}
          id="customized-dialog-title"
          className={dialogTitleClass}
        >
          <span> {title}</span>
          <p>{subtitle}</p>
          {closeIcon ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
      )}
      {dialogContent ? (
        <DialogContent className={dialogContentClass}>
          {dialogContent}
        </DialogContent>
      ) : null}
      {/* {dialogActions && (
                <DialogActions>
                    {dialogActions}
                </DialogActions>
            )} */}
    </BootstrapDialog>
  );
};

export default GlobalModal;
